(function () {
  const CSV_URL = "https://docs.google.com/spreadsheets/d/e/2PACX-1vS6ujR7NGRs2r8XMOk6SKKDYRg8bv51uSFgt3ha2SccK6U8MEjbvvto3DQLmg5OFQo7hFcFJkOroVUd/pub?gid=0&single=true&output=csv";

  async function getBLTCashData(code) {
    const response = await fetch(CSV_URL + "&t=" + Date.now(), {
      cache: "no-store"
    });

    const text = await response.text();
    const rows = text.trim().split(/\r?\n/).map(row => row.split(","));

    for (let i = 1; i < rows.length; i++) {
      const cashCode = (rows[i][0] || "").trim().toUpperCase();

      if (cashCode === code) {
        return {
          code: rows[i][0],
          balance: rows[i][1],
          validTill: rows[i][2],
          status: (rows[i][3] || "").trim().toLowerCase()
        };
      }
    }

    return null;
  }

  window.checkBLTCash = async function () {
    const input = document.getElementById("bltCode");
    const resultBox = document.getElementById("bltResult");

    if (!input || !resultBox) return;

    const code = input.value.trim().toUpperCase();

    if (!code) {
      resultBox.innerHTML = "Please enter your Cash Code.";
      return;
    }

    resultBox.innerHTML = "Checking...";

    try {
      const data = await getBLTCashData(code);

      if (!data) {
        resultBox.innerHTML = "Invalid BLT Cash Code.";
        return;
      }

      if (data.status !== "active") {
        resultBox.innerHTML = "This BLT Cash Code is inactive.";
        return;
      }

      resultBox.innerHTML = `
        <div style="border:1px solid #639060;border-radius:14px;padding:18px;">
          <div style="font-size:14px;opacity:.75;">Available BLT Cash</div>
          <div style="font-size:36px;font-weight:bold;color:#639060;">₹${data.balance}</div>
          <div style="font-size:14px;margin-top:8px;">Cash Code: ${data.code}</div>
          <div style="font-size:14px;">Valid Till: ${data.validTill}</div>
        </div>
      `;
    } catch (error) {
      resultBox.innerHTML = "Could not check balance. Please refresh and try again.";
    }
  };

  window.checkBLTCashCart = async function () {
    const input = document.getElementById("bltCodeCart");
    const resultBox = document.getElementById("bltResultCart");

    if (!input || !resultBox) return;

    const code = input.value.trim().toUpperCase();

    if (!code) {
      resultBox.innerHTML = "Enter a Cash Code.";
      return;
    }

    resultBox.innerHTML = "Checking...";

    try {
      const data = await getBLTCashData(code);

      if (!data) {
        resultBox.innerHTML = "Invalid Cash Code.";
        return;
      }

      if (data.status !== "active") {
        resultBox.innerHTML = "This Cash Code is inactive.";
        return;
      }

      resultBox.innerHTML = `Available BLT Cash: ₹${data.balance}`;
    } catch (error) {
      resultBox.innerHTML = "Unable to check balance.";
    }
  };
  window.checkBLTCashDrawer = async function () {
  const input = document.getElementById("bltCodeDrawer");
  const resultBox = document.getElementById("bltResultDrawer");

  if (!input || !resultBox) return;

  const code = input.value.trim().toUpperCase();

  if (!code) {
    resultBox.innerHTML = "Enter a Cash Code.";
    return;
  }

  resultBox.innerHTML = "Checking...";

  try {
    const data = await getBLTCashData(code);

    if (!data) {
      resultBox.innerHTML = "Invalid Cash Code.";
      return;
    }

    if (data.status !== "active") {
      resultBox.innerHTML = "This Cash Code is inactive.";
      return;
    }

    resultBox.innerHTML = `Available BLT Cash: ₹${data.balance}`;
  } catch (error) {
    resultBox.innerHTML = "Unable to check balance.";
  }
};
})();